import { useMyDataQuery } from '@/generated/graphql';
import { useAssistantAvailable } from '@/hooks/use-assistant-available';

/** Whether the viewer has the AI assistant, and whether that is known yet
 *  (gates must not decide while myData loads). An account already seen with
 *  the assistant is ready at once, so AI Studio doesn't wait on the refetch
 *  every page makes; a revoked flag still redirects once myData answers. */
export function useAiAssistantAccess(): { ready: boolean; enabled: boolean } {
  const { data, loading } = useMyDataQuery();
  const enabled = useAssistantAvailable(data?.myData?.subscription?.plan?.features, !!data?.myData);
  return {
    ready: !loading || enabled,
    enabled,
  };
}
